import moment from 'moment';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import React from 'react';

import {
  checkAvailability,
  destinationAirport,
  isDesktopDevice,
  is_weather_data_empty,
  load_facebook_api,
  insertIf
} from '../../../services/services';

import {
  offer_type_for_human,
  preparePlaceName
} from '../../../common/offer_utils';

import AdditionalInformations from '../../../common/components/additional_hints';
import AskForOffer from './ask_for_offer/ask_for_offer';
import Carousel from './gallery/carousel';
import DescriptionTab from './descriptions/description_tab';
import Facilities from './facilities';
import GalleryTab from './gallery_tab';
import HotelUpgradesList from './upgrades/index';
import Loader from '../../../common/components/loader';
import OfferDetails from './offer_details';
import OfferMap from './offer_map';
import OfferName from './offer_name';
import ReviewsTab from './reviews_tab';
import TabAccordion from '../../../common/components/accordion';
import Variants from './offer_variants';
import Weather from './weather/index';

import { T } from '../../../../../common/locale/translate';
import { offerTypes } from '../../../common/objects/offer_types';
import { scrollIt } from '../../../services/animate';
import WhyFromGermanyLink from './why_from_germany_link';
import {
  offerTabsNames,
  offerTabNamesToTabIds
} from '../../../common/objects/consts';

export default class Offer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      initialParams: this.props.initialParams,
      isOffer: this.props.isOffer,
      isLoaderVisible: true,
      isOfferAvailable: true,
      offerDetails: this.props.offer || false,
      personPricePln: 0,
      personPriceEur: 0,
      totalPricePln: 0,
      totalPriceEur: 0,
      detailsMessage: '',
      wasOfferVariantsListOpen: false,

      additionalHints: '',
      flights: props.offer.flights,
      flightsInterchanges: [],
      isAdditionalInfoTabVisible: false,

      selectedTab: null,
      selectedTabListItem: null,

      hotel_placeholder: '',
      trip_placeholder: '',
      placeholders: {
        offer: {
          S: '/img/placeholder/offer-hotel-placeholder.png',
          A: '/img/placeholder/offer-holiday-placeholder.png'
        },
        description: {
          S: '/img/placeholder/description-hotel-placeholder.png',
          A: '/img/placeholder/description-holiday-placeholder.png'
        }
      },
      tabs: [
        { key: 'terms_and_prices', name: T('terms_and_prices') },
        { key: 'description', name: T('description') },
        { key: 'facilities', name: T('facilities') },
        { key: 'location', name: T('hotel_location') },
        { key: 'gallery', name: T('gallery') },
        { key: 'reviews', name: T('hotel_reviews') },
        { key: 'flights_details', name: T('flights_details') },
        { key: 'weather', name: T('weather') },
        { key: 'info', name: T('aditional_info') }
      ]
    };
  }

  componentDidMount() {
    this.state.isOffer && this.checkAvailability();
    this.props.is_fb_visible &&
      load_facebook_api(document, 'script', 'facebook-jssdk');

    const selectedTab = isDesktopDevice() ? this.getDefaultTabIndex() : null;
    const selectedTabListItem = isDesktopDevice()
      ? this.getDefaultListItemIndex()
      : null;

    this.setState(
      {
        selectedTab,
        selectedTabListItem
      },
      () => {
        if (selectedTab === offerTabNamesToTabIds[offerTabsNames.MAP]) {
          this.onClickMapTab();
        } else if (
          selectedTab === offerTabNamesToTabIds[offerTabsNames.DATES]
        ) {
          this.initializeOfferVariants();
        }
      }
    );
  }

  render() {
    const isOffer = this.state.isOffer;
    let headerData = this.preparePageHeaderData();
    let offerGallery = this.props.offer.subject.image_urls || [];
    let departure =
      this.props.offer.departure_date ||
      this.props.initialParams.departure_date;
    let is_offer_expired = this.props.initialParams.is_offer_expired == 'true';

    let offerDetails = {},
      current_offer = { ...this.props.offer };
    let stars_rating = headerData.starsRating
      ? headerData.starsRating.toString().replace('.', '')
      : '';

    if (isOffer) {
      offerDetails = this.prepareOfferDetails();
      current_offer = {
        ...current_offer,
        price_eur: offerDetails.person_eur
          ? Math.ceil(parseFloat(offerDetails.person_eur))
          : Math.ceil(parseFloat(this.props.offer.price_eur)),
        price_pln: offerDetails.person_eur
          ? Math.ceil(parseFloat(offerDetails.person_pln))
          : Math.ceil(parseFloat(this.props.offer.price_pln)),
        price_total_eur: offerDetails.total_eur
          ? Math.ceil(parseFloat(offerDetails.total_eur))
          : Math.ceil(parseFloat(this.props.offer.price_total_eur)),
        price_total_pln: offerDetails.person_eur
          ? Math.ceil(parseFloat(offerDetails.total_pln))
          : Math.ceil(parseFloat(this.props.offer.price_total_pln))
      };
    }

    const tabs = this.prepareTabs();
    const tabPanels = this.prepareTabPanels();

    return (
      <div>
        {is_offer_expired && (
          <div className="exired-offer-notification">
            <p className="exired-error-message">
              <i className="fa fa-info-circle" />
              {T('offer_expired_1')}
              <a
                href="javascript:void(0)"
                onClick={() => this.remoteOpenTab('terms-and-prices')}
              >
                {T('offer_expired_2')}
              </a>
              {T('offer_expired_3')} {headerData.offerName}
            </p>
          </div>
        )}

        <div className="offer-inner-wrapper">
          <section className="offer-header">
            <OfferName
              offerName={headerData.offerName}
              placeName={headerData.placeName}
              weather={this.props.weather}
              departure_date={departure}
              starsRating={headerData.starsRating}
              isOffer={isOffer}
              offer={current_offer}
              token={this.props._token}
            />
          </section>
          <section className="facebook-section">
            {this.props.is_fb_visible && (
              <div
                className="fb-like"
                data-href={this.props.description_url}
                data-layout="button_count"
                data-action="like"
                data-size="large"
                data-show-faces="false"
                data-share="true"
              />
            )}
          </section>
          <section className="description">
            {offerGallery.length > 0 ? (
              <Carousel
                isOffer={isOffer}
                images={offerGallery}
                offer={current_offer}
                token={this.props._token}
              />
            ) : (
              this.renderPlaceholder()
            )}
            {isOffer &&
              this.state.isLoaderVisible && (
                <Loader
                  active={this.state.isLoaderVisible}
                  className="details-loader"
                />
              )}
            {isOffer &&
              !this.state.isLoaderVisible && (
                <OfferDetails
                  details={offerDetails}
                  params={this.props.initialParams}
                  isOffer={isOffer}
                  offer={current_offer}
                  token={this.props._token}
                  openFlightDetails={() =>
                    this.remoteOpenTab('additional_info_tab')
                  }
                />
              )}
          </section>

          {isOffer &&
            this.props.offer.subject.parser === 'urania' && (
              <section className="hotel-upgrades-wrapper">
                <HotelUpgradesList params={this.props.initialParams} />
              </section>
            )}

          {!isOffer && (
            <div className="buttons-container">
              <button
                className="show-dates-button"
                onClick={() => this.remoteOpenTab('terms-and-prices')}
              >
                {T('show_dates_with_prices')}
              </button>
              <AskForOffer
                offer={current_offer}
                token={this.props._token}
                type="description"
                params={this.props.initialParams}
              />
            </div>
          )}

          {isOffer && (
            <div className="mobile-offer-title">
              <div className="description-title">
                <h3>{headerData.offerName}</h3>
                <span className={`stars stars-${stars_rating}`} />
              </div>
            </div>
          )}
          <Tabs
            selectedIndex={this.state.selectedTabListItem}
            onSelect={this.onTabListItemSelected}
            forceRenderTabPanel={true}
          >
            <TabList className="nav nav-tabs">
              {tabs}
              <WhyFromGermanyLink link={this.props.why_from_germany_link} />
            </TabList>
            {tabPanels}
          </Tabs>
          <WhyFromGermanyLink
            className="for-mobile"
            link={this.props.why_from_germany_link}
          />
          <div className="ask-for-offer-btn-container">
            <AskForOffer
              className={`bottom${isOffer ? ' reservation-ask-for-offer' : ''}`}
              offer={current_offer}
              token={this.props._token}
              type={isOffer ? 'offer' : 'description'}
              params={this.props.initialParams}
            />
          </div>
        </div>
      </div>
    );
  }

  onClickMapTab = () => {
    this.refs['map_tab'].openMap();
  };

  mobileOnClickMapTab = index => {
    this.togglePanel(index);
    this.onClickMapTab();
  };

  initializeOfferVariants = () => {
    this.refs['offer_variants'].initialize();
  };

  renderPlaceholder = () => {
    const type = this.state.isOffer ? 'offer' : 'description';
    const offer_type = this.props.offer.offer_type;
    return (
      <div
        className={`placeholder-image ${type}`}
        style={{
          backgroundImage: `url(${this.state.placeholders[type][offer_type]})`
        }}
      />
    );
  };

  remoteOpenTab = tabID => {
    const tabs = document.querySelectorAll('.react-tabs')[0];
    const tab_node = document.getElementById(tabID);
    tab_node.click();
    scrollIt(tabs, 800, 'easeOutCubic');
  };

  mobileToggleOfferVariants = () => {
    if (!this.state.wasOfferVariantsListOpen) {
      this.initializeOfferVariants();
      this.setState({ wasOfferVariantsListOpen: true });
    }

    const isVariantsTabSelected =
      this.state.selectedTab === offerTabNamesToTabIds[offerTabsNames.DATES];
    this.setState({
      selectedTab: isVariantsTabSelected
        ? null
        : offerTabNamesToTabIds[offerTabsNames.DATES]
    });
  };

  toggleOfferVariants = () => {
    if (!this.state.wasOfferVariantsListOpen) {
      this.initializeOfferVariants();
      this.setState({ wasOfferVariantsListOpen: true });
    }
  };

  selectTab = tabName => {
    const tabIndex = offerTabNamesToTabIds[tabName];
    this.setState({ selectedTab: tabIndex });
  };

  togglePanel = tabIndex => {
    const isCurrentTabActive = this.state.selectedTab === tabIndex;
    this.setState({ selectedTab: isCurrentTabActive ? null : tabIndex });
  };

  onTabListItemSelected = itemIndex => {
    this.setState({
      selectedTabListItem: itemIndex
    });
  };

  prepareOfferDetails = () => {
    let offer = this.props.offer;
    let destination_airport = destinationAirport(offer);
    return {
      isOfferAvailable: this.state.isOfferAvailable,
      offerType: offer.offer_type,
      id: offer.subject.id,
      offerId: offer.id,
      parser: offer.subject.parser,
      trip_duration: offer.trip_duration,
      departure_date: offer.departure_date,
      return_date: offer.return_date,

      flight_from:
        typeof offer.flights != 'undefined'
          ? `${
              offer.flights[0].departure_airport_name
                ? offer.flights[0].departure_airport_name
                : ''
            } ${
              offer.flights[0].departure_airport_iata
                ? '[' + offer.flights[0].departure_airport_iata + ']'
                : ''
            }`
          : '',
      flight_to:
        typeof destination_airport != 'undefined' && destination_airport
          ? `${
              destination_airport.arrival_airport_name
                ? destination_airport.arrival_airport_name
                : ''
            } ${
              destination_airport.arrival_airport_iata
                ? '[' + destination_airport.arrival_airport_iata + ']'
                : ''
            }`
          : '',

      is_departure_from_germany:
        typeof offer.flights != 'undefined' &&
        offer.flights[0].is_departure_from_germany,

      adults_number: offer.adults_number,
      children_number: offer.children_ages ? offer.children_ages.length : 0,
      children_ages: offer.children_ages,

      alimentation: offer.boards.length > 0 ? offer.boards[0].name : ' - ',
      accommodation:
        offer.accommodation.polish_name || offer.accommodation.name,
      operator: offer.operator.name || ' - ',
      operatorLogoUrl: offer.operator.logo_url,
      operatorCode: offer.operator.code,

      person_pln: parseFloat(this.state.personPricePln).toFixed(2),
      person_eur: parseFloat(this.state.personPriceEur).toFixed(2),
      total_pln: parseFloat(this.state.totalPricePln).toFixed(2),
      total_eur: parseFloat(this.state.totalPriceEur).toFixed(2),
      message: this.state.detailsMessage
    };
  };

  checkAvailability = () => {
    let offer = this.props.offer;
    let paramsToSend = {
      parser: offer.subject.parser,
      operator_code: offer.operator.code,
      hotel_id: offer.subject.id,
      adults_number: offer.adults_number,
      children_ages: offer.children_ages.join(','),
      offer_type: offer.offer_type,
      offer_id: offer.id,
      departure_date: moment(offer.departure_date).unix(),
      return_date: moment(offer.return_date).unix()
    };

    checkAvailability(paramsToSend)
      .then(response => {
        let updatedData = response.data;
        let availability_code = updatedData.availability.code;

        let flightsInterchanges =
          updatedData.flights.length > 0 ? updatedData.flights : [];
        let isAdditionalInfoTabVisible = Boolean(
          flightsInterchanges.length > 0 || updatedData.hints
        );

        if (availability_code == 'NA' || availability_code == 'XX') {
          this.setState({
            isLoaderVisible: false,
            isOfferAvailable: false,
            detailsMessage: T('sorry_offer_is_unavailable')
          });
        } else {
          this.setState({
            isLoaderVisible: false,
            isOfferAvailable: true,
            personPricePln: updatedData.price_pln,
            personPriceEur: updatedData.price_eur || 0,
            totalPricePln: updatedData.price_total_pln || 0,
            totalPriceEur: updatedData.price_total_eur || 0,

            flightsInterchanges: flightsInterchanges,
            additionalHints: updatedData.hints,
            isAdditionalInfoTabVisible: isAdditionalInfoTabVisible
          });
        }
      })
      .catch(() => {
        this.setState({
          isLoaderVisible: false,
          isOfferAvailable: false,
          detailsMessage: T('sorry_error_occured')
        });
      });
  };

  preparePageHeaderData = () => {
    return {
      offerName: this.prepareOfferName(this.props.offer),
      placeName: preparePlaceName(this.props.offer.subject),
      starsRating: this.props.offer.subject.rating
    };
  };

  prepareOfferName = offer => {
    if (offer.subject.name) {
      return offer.subject.name;
    } else {
      return offer_type_for_human(offer.offer_type);
    }
  };

  prepareTabs = () => {
    const tabs_visibility = this.getTabsVisibility();
    const is_hotel_only = this.props.offer.offer_type === offerTypes.hotel_only;

    return [
      <Tab
        onClick={() => {
          this.selectTab(offerTabsNames.DATES);
          this.toggleOfferVariants();
        }}
      >
        <a
          href="javascript:void(0)"
          id="terms-and-prices"
          title={T('terms_and_prices')}
        >
          <span className="fa fa-calendar" />
          {this.state.tabs[0].name}
        </a>
      </Tab>,
      ...insertIf(
        tabs_visibility.is_description_tab_visible,
        <Tab onClick={() => this.selectTab(offerTabsNames.DESCRIPTION)}>
          <a href="javascript:void(0)" title={T('go_to_description')}>
            {this.state.tabs[1].name}
          </a>
        </Tab>
      ),
      ...insertIf(
        tabs_visibility.is_map_visible,
        <Tab
          onClick={() => {
            this.selectTab(offerTabsNames.MAP);
            this.onClickMapTab();
          }}
        >
          <a href="javascript:void(0)" title={T('show_map')}>
            {this.state.tabs[3].name}
          </a>
        </Tab>
      ),
      ...insertIf(
        tabs_visibility.is_facilities_tab_visible,
        <Tab onClick={() => this.selectTab(offerTabsNames.FACILITIES)}>
          <a href="javascript:void(0)" title={T('facilities_list')}>
            {this.state.tabs[2].name}
          </a>
        </Tab>
      ),
      ...insertIf(
        tabs_visibility.is_gallery_visible,
        <Tab
          onClick={() => {
            this.selectTab(offerTabsNames.GALLERY);
          }}
        >
          <a href="javascript:void(0)" title={T('show_gallery')}>
            {this.state.tabs[4].name}
          </a>
        </Tab>
      ),
      ...insertIf(
        tabs_visibility.are_reviews_visible,
        <Tab onClick={() => this.selectTab(offerTabsNames.REVIEWS)}>
          <a href="javascript:void(0)" title={T('show_hotel_reviews')}>
            {this.state.tabs[5].name}
          </a>
        </Tab>
      ),
      ...insertIf(
        tabs_visibility.is_additional_information_visible,
        <Tab
          onClick={() => this.selectTab(offerTabsNames.ADDITIONAL_INFORMATION)}
        >
          <a
            href="javascript:void(0)"
            title={T('show_flight_details')}
            id="additional_info_tab"
          >
            {is_hotel_only ? '' : <span className="fa fa-plane" />}
            {is_hotel_only ? this.state.tabs[8].name : this.state.tabs[6].name}
          </a>
        </Tab>
      ),
      ...insertIf(
        tabs_visibility.is_weather_visible,
        <Tab onClick={() => this.selectTab(offerTabsNames.WEATHER)}>
          <a href="javascript:void(0)" title={T('weather')}>
            {this.state.tabs[7].name}
          </a>
        </Tab>
      )
    ];
  };

  prepareTabPanels = () => {
    const tabs_visibility = this.getTabsVisibility();
    const is_hotel_only = this.props.offer.offer_type === offerTypes.hotel_only;
    const headerData = this.preparePageHeaderData();
    const offerAlt = headerData.offerName;
    const offerGallery = this.props.offer.subject.image_urls || [];
    const coordinates = {
      latitude: this.props.offer.subject.latitude,
      longitude: this.props.offer.subject.longitude
    };
    const offerFacilities = this.props.offer.subject.facilities;

    return [
      <TabAccordion
        index={offerTabNamesToTabIds[offerTabsNames.DATES]}
        headerIcon="fa-calendar"
        headerName={T('terms_and_prices')}
        switchActiveTab={this.mobileToggleOfferVariants}
        selectedTab={this.state.selectedTab}
      >
        <TabPanel>
          <Variants
            initialParams={this.props.initialParams}
            offer_type={this.props.offer.offer_type}
            offer={this.props.offer}
            ref="offer_variants"
          />
        </TabPanel>
      </TabAccordion>,
      ...insertIf(
        tabs_visibility.is_description_tab_visible,
        <TabAccordion
          index={offerTabNamesToTabIds[offerTabsNames.DESCRIPTION]}
          headerIcon="fa-file-text-o"
          headerName={this.state.tabs[1].name}
          switchActiveTab={this.togglePanel}
          selectedTab={this.state.selectedTab}
        >
          <TabPanel>
            <DescriptionTab
              description={this.state.offerDescription}
              descriptionProviders={this.props.descriptionProviders}
              originalProvider={this.props.offer.operator}
              hotelId={this.props.offer.subject.id}
              parser={this.props.offer.subject.parser}
              operator_priority_code="AMIGOSBB"
              client_language={this.props.i18n_locale}
              default_language={this.props.default_language}
              offerName={headerData.offerName}
              starsRating={headerData.starsRating}
              allow_description_export={this.props.allow_description_export}
            />
          </TabPanel>
        </TabAccordion>
      ),
      ...insertIf(
        tabs_visibility.is_map_visible,
        <TabAccordion
          index={offerTabNamesToTabIds[offerTabsNames.MAP]}
          headerIcon="fa-map-marker"
          headerName={this.state.tabs[3].name}
          switchActiveTab={this.mobileOnClickMapTab}
          selectedTab={this.state.selectedTab}
        >
          <TabPanel>
            <OfferMap ref="map_tab" coordinates={coordinates} />
          </TabPanel>
        </TabAccordion>
      ),
      ...insertIf(
        tabs_visibility.is_facilities_tab_visible,
        <TabAccordion
          index={offerTabNamesToTabIds[offerTabsNames.FACILITIES]}
          headerIcon="fa-smile-o"
          headerName={this.state.tabs[2].name}
          switchActiveTab={this.togglePanel}
          selectedTab={this.state.selectedTab}
        >
          <TabPanel>
            <Facilities facilities={offerFacilities} />
          </TabPanel>
        </TabAccordion>
      ),
      ...insertIf(
        tabs_visibility.is_gallery_visible,
        <TabAccordion
          index={offerTabNamesToTabIds[offerTabsNames.GALLERY]}
          headerIcon="fa-photo"
          headerName={this.state.tabs[4].name}
          switchActiveTab={this.togglePanel}
          selectedTab={this.state.selectedTab}
        >
          <TabPanel>
            <GalleryTab images={offerGallery} imageAlt={offerAlt} />
          </TabPanel>
        </TabAccordion>
      ),
      ...insertIf(
        tabs_visibility.are_reviews_visible,
        <TabAccordion
          index={offerTabNamesToTabIds[offerTabsNames.REVIEWS]}
          headerIcon="fa-quote-right"
          headerName={this.state.tabs[5].name}
          switchActiveTab={this.togglePanel}
          selectedTab={this.state.selectedTab}
        >
          <TabPanel>
            <ReviewsTab
              subject={this.props.offer.subject}
              lang={this.props.i18n_locale}
            />
          </TabPanel>
        </TabAccordion>
      ),
      ...insertIf(
        tabs_visibility.is_additional_information_visible,
        <TabAccordion
          headerIcon="fa-plane"
          index={offerTabNamesToTabIds[offerTabsNames.ADDITIONAL_INFORMATION]}
          headerName={
            is_hotel_only ? this.state.tabs[8].name : this.state.tabs[6].name
          }
          switchActiveTab={this.togglePanel}
          selectedTab={this.state.selectedTab}
        >
          <TabPanel>
            <AdditionalInformations
              hints={this.state.additionalHints}
              flights={this.state.flights}
              flight_interchanges={this.state.flightsInterchanges}
            />
          </TabPanel>
        </TabAccordion>
      ),
      ...insertIf(
        tabs_visibility.is_weather_visible,
        <TabAccordion
          headerIcon="fa-sun-o"
          index={offerTabNamesToTabIds[offerTabsNames.WEATHER]}
          headerName={this.state.tabs[7].name}
          switchActiveTab={this.togglePanel}
          selectedTab={this.state.selectedTab}
        >
          <TabPanel>
            <Weather data={this.props.weather} />
          </TabPanel>
        </TabAccordion>
      )
    ];
  };

  getTabsVisibility = () => ({
    is_description_tab_visible:
      this.props.descriptionProviders.length > 1 ||
      (this.props.descriptionProviders.length === 1 &&
        this.props.descriptionProviders[0].code != null),
    is_map_visible: this.props.offer.subject.latitude,
    is_facilities_tab_visible: this.props.offer.subject.facilities.length > 0,
    is_gallery_visible:
      this.props.offer.subject.image_urls &&
      this.props.offer.subject.image_urls.length > 0,
    are_reviews_visible:
      ReviewsTab.hasTrustYouReview(this.props.offer.subject) ||
      ReviewsTab.hasZooverReviews(this.props.offer.subject),
    is_additional_information_visible: this.state.isAdditionalInfoTabVisible,
    is_weather_visible: is_weather_data_empty(this.props.weather)
  });

  getDefaultTabIndex = () => {
    const visibleTabIndexes = this.getVisibleTabIndexes();
    return visibleTabIndexes.length > 1
      ? visibleTabIndexes[1]
      : visibleTabIndexes[0];
  };

  getDefaultListItemIndex = () => {
    const visibleTabIndexes = this.getVisibleTabIndexes();
    return visibleTabIndexes.length > 1 ? 1 : 0;
  };

  getVisibleTabIndexes = () => {
    const tabs_visibility = this.getTabsVisibility();

    return [
      offerTabNamesToTabIds[offerTabsNames.DATES],
      ...insertIf(
        tabs_visibility.is_description_tab_visible,
        offerTabNamesToTabIds[offerTabsNames.DESCRIPTION]
      ),
      ...insertIf(
        tabs_visibility.is_map_visible,
        offerTabNamesToTabIds[offerTabsNames.MAP]
      ),
      ...insertIf(
        tabs_visibility.is_facilities_tab_visible,
        offerTabNamesToTabIds[offerTabsNames.FACILITIES]
      ),
      ...insertIf(
        tabs_visibility.is_gallery_visible,
        offerTabNamesToTabIds[offerTabsNames.GALLERY]
      ),
      ...insertIf(
        tabs_visibility.are_reviews_visible,
        offerTabNamesToTabIds[offerTabsNames.REVIEWS]
      ),
      ...insertIf(
        tabs_visibility.is_additional_information_visible,
        offerTabNamesToTabIds[offerTabsNames.ADDITIONAL_INFORMATION]
      ),
      ...insertIf(
        tabs_visibility.is_weather_visible,
        offerTabNamesToTabIds[offerTabsNames.WEATHER]
      )
    ];
  };
}



// WEBPACK FOOTER //
// ./app/javascript/pages/offer/components/offer.jsx